import { render, staticRenderFns } from "./hkResult.vue?vue&type=template&id=4f630d07"
import script from "./hkResult.vue?vue&type=script&lang=js"
export * from "./hkResult.vue?vue&type=script&lang=js"
import style0 from "./hkResult.vue?vue&type=style&index=0&id=4f630d07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports